export default __webpack_public_path__ + "static/media/cart.8035a91d.svg";